import React from "react"
import { Grid } from "semantic-ui-react"
import { Redirect, Route } from "react-router-dom"
import TabNavTopNavigation from "./TabNavTopNavigation"
import TabNavSection from "./TabNavSection"
import TabNavSubSection from "./TabNavSubSection"
import TabNavIntroduction from "./TabNavIntroduction"
import "./TabNav.css"

const TabNav = ({ children, pathname }) => {
  const validSections = React.Children.toArray(children).filter(
    child =>
      child && child.type.displayName === "TabNavSection" && !child.props.skip()
  )
  const sections = validSections.map(section => {
    return {
      name: section.props.name,
      title: section.props.title,
      icon: section.props.icon,
      cornerLabel: section.props.cornerLabel,
      activeImage: section.props.activeImage,
      inactiveImage: section.props.inactiveImage,
      disabled: section.props.disabled,
      showIntroduction: section.props.showIntroduction,
      subsectionNames: React.Children.toArray(section.props.children)
        .filter(child => child.type.displayName === "TabNavSubSection")
        .map(subsection => subsection.props.name)
    }
  })
  const pathParts = pathname.split("/").filter(path => path !== "")
  const pathExists =
    sections.filter(sec => sec.name === pathParts[0]).length > 0
  if (!pathExists) {
    return <Redirect to={"/home"} />
  }
  const curSection = sections.filter(sec => sec.name === pathParts[0])[0]
  if (
    !curSection.subsectionNames.includes(pathParts[1]) &&
    pathParts[1] !== "introduction" &&
    !curSection.showIntroduction
  ) {
    return (
      <Redirect to={"/" + pathParts[0] + "/" + curSection.subsectionNames[0]} />
    )
  }
  return (
    <Grid className="white TabNav__Grid">
      <TabNavTopNavigation sections={sections} />
      <Grid.Row>
        <Grid.Column>
          <Route
            exact
            path="/"
            render={() => <Redirect to={"/" + children[0].props.name} />}
          />
          {validSections.filter(child => !child.props.disabled)}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

TabNav.Section = TabNavSection
TabNav.SubSection = TabNavSubSection
TabNav.Introduction = TabNavIntroduction
export default TabNav
